import { SvgIcon } from '@mui/material';
import React, { useContext } from 'react';
import I18n from '../common/i18n/I18n';
import { Icons } from '../common/icons/Icons';
import useHistory from '../common/utils/useHistory';
import { UserContext } from '../common/auth/UserContext';
import NotFound from '../common/components/NotFound';

export default () => {
    const { application } = useContext(UserContext);
    const { changeRoute } = useHistory();

    return (
        <NotFound
            ImageIcon={<SvgIcon component={Icons.AddProductionIcon} sx={{ fontSize: '240px' }} />}
            text={<I18n token="production.data.grid.no.rows.message" />}
            title={<I18n token="production.data.grid.no.rows.start.collaboration" />}
            disableStartIcon
            button
            allowedEdit
            buttonText="production.data.grid.button.create.production"
            buttonVariant="contained"
            onClick={() => changeRoute(`${application.home}/workspace/create`)}
            sx={{ alignItems: 'center', justifyContent: 'center', gap: 1 }}
        />
    );
};
